import React, { useState, useEffect, useContext } from "react";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { Helmet } from "react-helmet-async";
import { CircularProgress } from "@mui/material";
import Context from "../Master/SessionProvider";
import enviarPeticion from "../../tools/EnviarPeticion";
import formatDatetime from "../../tools/FormatDatetime";
import { ALTA, HISTORIAL } from "../../tools/ApiRoutes";
import APP from "../../tools/AppRoutes";
import BotonCS from "../../components/BotonCS";
import TableCS from "../../components/TableCS";
import Alert from "../../components/Alert";
import TextFieldCS from "../../components/TextFieldCS";
import AutocompleteCS from "../../components/AutocompleteCS";

const Altas = ({history}) => {
    const { user, seleccionar } = useContext(Context);

    const [ alert , setAlert ] = useState({ msg: '', severity: 'success', open: false }); //MODAL NOTIFICACIONES
    const [ loading, setLoading ] = useState(true);
    const [ listaAltas, setListaAltas ] = useState([]);
    const [ listaAltasAC, setListaAltasAC ] = useState([]);
    const [ listaAltasTemp, setListaAltasTemp ] = useState([]);
    const [ buscar, setBuscar ] = useState('');

    const columnasTabla = [
        { title: "Razón Social", field: "RazonSocial" },
        { title: "NIT", field: "NIT"},
        { title: "Email", field: "Email" },
        { title: "Fecha Registro", field: "FechaRegistro", render: (row) => {
            return formatDatetime(row.FechaRegistro);
        }, },
        { title: "", render: (row) => {
            return(
                <>

                    <button onClick={(event) => { VerDetalle(event, row) }} style={{border: 'none', padding: '0', backgroundColor: 'inherit', color: 'blue'}}><span>Ver Detalle</span></button>
                </>
            )
        }},
    ];

    const VerDetalle = (event, row) => {
        event.preventDefault();
        seleccionar(row);
        window.scrollTo(0,0);
        history.push(APP.DETALLEALTA);
    }

    //GUARDA LOS FILTROS SELECCIONADOS
    const filtrar = (event) => {

        if (event.target.innerText !== ""){
            let copia = listaAltas.filter(item => item.RazonSocial.toLowerCase().includes(event.target.innerText.toLowerCase()));

            setListaAltasTemp(copia);

            if (copia.length < 1) setAlert({ msg: 'No se encontraron resultados', severity: 'info', open: true });
        }
        else{
            setListaAltasTemp(listaAltas);
        }
    }

    const handleBuscar = (event) => { 
        event.preventDefault();
        setBuscar(event.target.value);
    }

    //CIERRA MENSAJE DE VALIDACIÓN
    const closeAlert = () => setAlert({ msg: '', severity: 'success', open: false });

    const llenarAltas = async () => {

        const config = {
            method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                }
        };

        const res = await enviarPeticion(config, ALTA.Altas);
        setListaAltas(res.data);

        return res.data;
    }

    const llenarListaFiltro = async () => {

        const config = {
            method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                }
        };

        const res = await enviarPeticion(config, `${HISTORIAL.ListaFiltro}?param=altas`);

        setListaAltasAC(res.data);
    }

    useEffect(() => {
        
        const inicio = async () =>{
            const data = await llenarAltas();
            setListaAltasTemp(data);

            await llenarListaFiltro();
            setLoading(false);
        }

        //VALIDAMOS LA SESIÓN
        if (user.Usuario === '' || user.Usuario === null || user.Usuario === undefined){
            history.push(APP.INDEX);
        }
        else{
            inicio();
        }

        return (() => {
            //console.log("");
        });

    }, []);

     return (<>
     <Helmet>
        <title>Altas Pendientes</title>
     </Helmet>

     {
        loading ?
        <div className={'container'}>
            <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={100} thickness={2}></CircularProgress>
            </div>
        </div>
        :
        <div className={'container'}>
            <div className="fontNewsGothic">
                <div className="col-sm-12 col-md-12 col-lg-12">

                    {
                        alert.open ? <Alert msg={alert.msg} open={alert.open} severity={alert.severity} segundos={alert.segundos ? alert.segundos : 6} closeAlert={closeAlert}/> : <></>
                    }

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Altas Pendientes</label>
                    </div>
                    <br />
                    <br />

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                            <AutocompleteCS items={listaAltasAC} placeholder='Buscar cliente...' fn={filtrar}></AutocompleteCS>
                            {/* <TextFieldCS id='txtRazonSocial' placeholder='Razón Social' value={buscar} onChange={handleBuscar}></TextFieldCS> */}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                            {/* <BotonCS title='Buscar' handleSubmit={filtrar}></BotonCS> */}
                        </div>
                                                
                    </div>
                    <br />
                    <br />

                    <TableCS
                        columns={columnasTabla}
                        data={listaAltasTemp}
                    />
                    <br />
                    <br />
                    <br />
                    <br />

                </div>
            </div>
        </div>

     }
     </>)
}

export default React.memo(withRouter(Altas));